(function ( $ ) {
	
	"use strict";
	
    var scrollAnimateReady = false,
        scrollTime = Date.now(),
        scrollThreshold = 100,
        scrollHeightOffsetPercent = 25,
        queueDelay = 300,
        animateInitClass = 'scroll-animate-init',
        animateInClass = 'scroll-animate-in',
        animateInSectionClass = 'scroll-animate-in-section',
        animateType,
        sections = 'div.jr-layout, div.main-content',
        $sections,
        counter = 0,
        $animationElements;

    $(document).ready(function() {

        if ( ! $('body').hasClass('jr-scroll-animate') ) {
            return;
        }

        scrollAnimateReady = true;
        $sections = $( sections );

		if ( $('body').hasClass('jr-sa_animate_content') ) {
			animateType = 'content';

            // Set all initial classes
            $sections.each( function() {

                var $section = $(this);

                if ( $section.hasClass('layout-content') ) { // Content layout

                    $animationElements = $section.find('div.main-section > div.column').addClass(animateInitClass);

                } else { // All other layouts

                    $animationElements = $section.find('div.jr-layout-inner, div.entry-content').addClass(animateInitClass);

                }

            });

		} else {
			animateType = 'layout';
		}

        setTimeout(function(){ 
            cycleThroughElements();
        }, 500);

        $(window).scroll( function() {

            if ( scrollAnimateReady === false ) {
                return;
            }

            if ( Date.now() - scrollTime < scrollThreshold ) {
                return;
            }

            scrollTime = Date.now();

            cycleThroughElements();

        });

        // When scrolling has stopped
        $(window).on('scroll', function(e) {
            cycleThroughElements();
        }, scrollThreshold);
        

	});


    





    function cycleThroughElements() {

        var windowHeight = $(window).height();
        var documentHeight = $(document).height();
        var pageTop = $(document).scrollTop();
        var pageBottom = pageTop + windowHeight;
        var pageBottomDistance = documentHeight - pageBottom;
        var bottomOfPage = false;
        var scrollHeightOffset = windowHeight * ( scrollHeightOffsetPercent / 100 );

        if ( pageBottomDistance <= scrollHeightOffset ) {
            scrollHeightOffset = pageBottomDistance;
        }

        var bottomOffset = pageBottom - scrollHeightOffset;

        $sections = $( sections );
        var sectionCounter = 0;

        // Loop through all sections
        $sections.each( function() {

            sectionCounter++;

            var $section = $(this);

            // Check if this section has already been animated
            if ( $section.hasClass( animateInSectionClass ) ) {
                return true;
            }

            // Check if this section is above the threshold
            if ( 
                $section.offset().top > bottomOffset &&
                bottomOfPage === false
            ) {
                return true;
            }

            // If we are animating the content
            if ( animateType === 'content' ) {

                if ( $section.hasClass('layout-content') ) { // Content layout

                    $animationElements = $section.find('div.main-section > div.column');

                } else { // All other layouts

                    $animationElements = $section.find('div.jr-layout-inner, div.entry-content');

                }
            
            // If we are animating the whole section  
            } else {

                $animationElements = $section;

            }

            // Loop through all elements to animate
            $animationElements.each( function() {

                var $this = $(this);

                $(document).queue( 'scrollAnimate' + sectionCounter, function( next ) {

                    

                    $this.addClass( animateInClass );

                    setTimeout(function(){ 
                        next(); 
                    }, queueDelay);

                });

            });

            $section.addClass( animateInSectionClass );

            $(document).dequeue( 'scrollAnimate' + sectionCounter );
            

        });

    }

}( jQuery ));